<template>
    <b-navbar>
        <b-navbar-brand href="#" v-text="viewname"></b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav class="ml-auto">
                <b-nav-item-dropdown right>
                    <template v-slot:button-content>
                      <span class="profile__name">{{name}}</span><img class="profile__avatar" v-bind:src="avatar" />
                    </template>
                    <b-dropdown-item
                            active-class="active"
                            to="/profile">
                        <img class="icon" src="/images/icon/navigation/icon_profile.svg"/>
                        <span class="text">{{ $t('navigation.profile') }}</span>
                    </b-dropdown-item>
                    <b-dropdown-item
                            active-class="active"
                            to="/settings">
                        <img class="icon" src="/images/icon/navigation/icon_reporttemplate.svg"/>
                        <span class="text">{{ $t('navigation.settings') }}</span>
                    </b-dropdown-item>
                    <b-dropdown-item
                      active-class="active"
                      to="/toolbox">
                      <img class="icon" src="/images/icon/navigation/icon_toolbox.svg"/>
                      <span class="text">{{ $t('navigation.toolbox') }}</span>
                    </b-dropdown-item>
                    <b-dropdown-item
                            active-class="active"
                            to="/payment">
                        <img class="icon" src="/images/icon/navigation/icon_payment.svg"/>
                        <span class="text">{{ $t('navigation.payment') }}</span>
                    </b-dropdown-item>
                    <b-dropdown-item
                            active-class="active"
                            to="/invoices">
                        <img class="icon" src="/images/icon/navigation/icon_invoice.svg"/>
                        <span class="text">{{ $t('navigation.invoices') }}</span>
                    </b-dropdown-item>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item
                            active-class="active"
                            to="/dpa">
                        <img class="icon" src="/images/icon/navigation/icon_gdpr.svg"/>
                        <span class="text">{{ $t('navigation.dpainfo') }}</span>
                    </b-dropdown-item>
                    <b-dropdown-item
                            active-class="active"
                            to="/support">
                        <img class="icon" src="/images/icon/navigation/icon_support.svg"/>
                        <span class="text">{{ $t('navigation.support') }}</span>
                    </b-dropdown-item>
                    <b-dropdown-item v-on:click="localLogout">
                        <img class="icon" src="/images/icon/navigation/icon_logout.svg"/>
                        <span class="text">{{ $t('navigation.logout') }}</span>
                    </b-dropdown-item>
                </b-nav-item-dropdown>
            </b-navbar-nav>
        </b-collapse>
    </b-navbar>
</template>
<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'TheNavbar',

  computed: {
    ...mapState(['viewname']),

    ...mapState('user', [
      'userLastname',
      'userFirstname',
      'userEmail',
      'remainingfreedays',
      'userAvatar'
    ]),

    name () {
      if (this.userLastname === '' && this.userFirstname === '') {
        return this.userEmail
      }
      if (this.userLastname === '') {
        return this.userFirstname
      }
      if (this.userFirstname === '') {
        return this.userLastname
      }

      return this.userFirstname + ' ' + this.userLastname
    },

    avatar () {
      return this.userAvatar
    }
  },
  methods: {

    ...mapMutations(['toggleMenu']),
    ...mapMutations('user', ['logout']),

    localLogout () {
      this.logout()
      window.location.reload()
    }

  }
}
</script>
